import React from 'react';

import { Button, DialogActions, Stack } from '@mui/material';

import { PACKAGE_SETUP_FORM_ID, PROPERTY_FORM_ID, STEPS, TAXES_FEES_FORM_ID } from './constants';

interface Props {
  activeStep: number;
  contentPageUrl: string;
  isContentStep: boolean;
  isCreatePropertyStep: boolean;
  isPackageSetupStep: boolean;
  isPrerequisitesStepNextDisabled: boolean;
  isPropertyStepNextDisabled: boolean;
  isRatePlanStep: boolean;
  isRatePlanStepNextDisabled: boolean;
  isRoomRatesStepNextDisabled: boolean;
  isRoomStepNextDisabled: boolean;
  isStepBusy: boolean;
  isTaxesAndFeesStep: boolean;
  onGoToContentPage: () => void;
  onNext: () => void;
  onPrevious: () => void;
  primaryButtonLabel: string;
  trimmedSalesforceOfferId: string;
}

export default function WizardActions({
  activeStep,
  contentPageUrl,
  isContentStep,
  isCreatePropertyStep,
  isPackageSetupStep,
  isPrerequisitesStepNextDisabled,
  isPropertyStepNextDisabled,
  isRatePlanStep,
  isRatePlanStepNextDisabled,
  isRoomRatesStepNextDisabled,
  isRoomStepNextDisabled,
  isStepBusy,
  isTaxesAndFeesStep,
  onGoToContentPage,
  onNext,
  onPrevious,
  primaryButtonLabel,
  trimmedSalesforceOfferId,
}: Props) {
  const submitsCurrentStep = isCreatePropertyStep || isTaxesAndFeesStep || isPackageSetupStep;

  return (
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button onClick={onPrevious} disabled={activeStep === 0 || isContentStep || isStepBusy}>
        Previous
      </Button>
      <Stack direction="row" spacing={1}>
        {activeStep === STEPS.length - 1 ? (
          <Button variant="contained" onClick={onGoToContentPage} disabled={!contentPageUrl}>
            Go to CM Checklist
          </Button>
        ) : (
          <Button
            variant="contained"
            form={
              isCreatePropertyStep
                ? PROPERTY_FORM_ID
                : isTaxesAndFeesStep
                  ? TAXES_FEES_FORM_ID
                  : isPackageSetupStep
                    ? PACKAGE_SETUP_FORM_ID
                    : undefined
            }
            type={submitsCurrentStep ? 'submit' : 'button'}
            onClick={submitsCurrentStep ? undefined : onNext}
            disabled={
              (activeStep === 0 && !trimmedSalesforceOfferId) ||
              isStepBusy ||
              isPrerequisitesStepNextDisabled ||
              isPropertyStepNextDisabled ||
              (isRatePlanStep && isRatePlanStepNextDisabled) ||
              isRoomStepNextDisabled ||
              isRoomRatesStepNextDisabled
            }
          >
            {primaryButtonLabel}
          </Button>
        )}
      </Stack>
    </DialogActions>
  );
}
